import styled from 'styled-components';
import Navbar from './Navbar';
import { useState, useEffect } from 'react'
import React from 'react';

const Header = ({icon}) => {

    const [offSetY, setOffSetY] = useState(0)

    const handleParallax = () => {
        setOffSetY(window.pageYOffset);
            (
            window.pageYOffset > 5
            ?
            document.querySelector('.page-icon').style.opacity = 0
            : document.querySelector('.page-icon').style.opacity = 1
            );
        }

    useEffect(() => {
        window.addEventListener('scroll', handleParallax)
        return () => {
            window.removeEventListener('scroll',handleParallax)
        }
    }, [])

    return (
            <Contents>
                <div className="flex-wrapper">
                    <div className="flex">
                    <h1
                    style = {
                        { transform: `translateY(${offSetY * 0.4}px)`}
                    }
                    >THE ROYAL</h1>
                        <p
                        style = {
                            { transform: `translateY(${offSetY * 0.4}px)`}
                        }
                        >Stainless Steel Fabricators</p>
                        <i className={icon}></i>
                        <div className="scroll-icons">
                            <i className="scroll1 fas fa-chevron-down"></i>
                            <i className="scroll2 fas fa-chevron-down"></i>
                        </div>
                    </div>
                    <Navbar />
                </div>
            </Contents>
    )
}

const Contents = styled.div`
    width: 100%;
    height: 100vh;
    background: #000 url('/images/handss.jpeg') no-repeat scroll center;
    background-size: cover;
    font-family: 'Poppins', Helvetica, sans-serif;
    @media screen and (orientation: landscape) {
        background: #000 url('/images/desktopbg.jpeg') no-repeat scroll center;
        background-size: cover;
    }
    .flex-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    background: rgba(0,0,0,0.5);
    }
    .flex {
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: center;
        flex: 1;
    }
    * {
        color: #fff;
        font-weight: 600;
    }

    h1,p {
        margin: 0 1rem;
    }

    h1 {
        font-weight: 900;
    }
    .sticky {
    background: rgba(0,0,0,0.7);
    position: fixed;
    top: 0;
    left: 0;
    color: #fff;
    }
    .page-icon {
        font-size: 3rem;
        margin-top: 2rem;
        cursor: alias;
    }
    .scroll-icons {
        min-height: 5rem;
        position: absolute;
        bottom: 80px;
    }
    .fa-chevron-down {
        font-size: 2rem;
        display: block;
        cursor: none;
    }
    .scroll1 {
        animation: scroll-down 1s linear 1s infinite 
    }
    .scroll2 {
        animation: scroll-down 1s linear 1.2s infinite;
    }
    @media screen and (max-height: 400px ) {
        .fa-chevron-down,.page-icon {
            font-size: 1rem
        }
        .scroll-icons {
            bottom: 0
        }
    }
    @keyframes scroll-down {
        0%,100% {
            opacity: 0;
            transform: translateX(0);
        }
        20% {
            opacity: 0.8;
            transform: translateX(0);
        }
        50% {
            opacity: 0.5;
            transform: translateX(0);
        }
        80% {
            opacity: 0.2;
            transform: translateY(1rem);
        }
    }
`;
export default React.memo(Header);